export const setApplicationConfig = (config) =>{
    return{
        type:'SET_APPLICATION_CONFIG',
        value:config
    }
};

export const setRejectionReasons = (reasons) =>{
    return {
        type : 'SET_REJECTION_REASONS',
        value : reasons
    }
};
export const setAgreementRejectionReasons = (reasons) =>{
    return {
        type : 'SET_AGREEMENT_REJECTION_REASONS',
        value : reasons
    }
};

export const setStandardGoUrls = (urls) =>{
    return{
        type : 'SET_STANDARD_GO_URLS',
        value : urls
    }
};

export const setSourceAvailability = (systems) =>{
    return{
        type : 'SET_SOURCE_AVAILABILITY',
        value : systems
    }
};

export const loadConfig = () =>{
    return{
        type : 'LOAD_CONFIG'
    }
};

export const setFeatureFlag = (featureflagList) => {
    return {
        type: 'SET_FEATURE_FLAG',
        value : featureflagList
    }
}